import { Div, Text } from 'ui/index'
import useResponsive from 'utils/hooks/useResponsive'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Header from './Header'
import PeopleImage from './PeopleImage'
import { Container } from './styles'

const Hero = () => {

  const { t } = useTranslation()
  const { isMobile, isTab } = useResponsive()


  return (
    <Container>
      <Header />

      <Div
        width='90%'
        maxWidth={isMobile ? 400 : 700}
        margin='0 auto'
        textAlign='center'
      >
       <Text
          size={isMobile ? '2xl' : '5xl'}
          align='center'
          color='headline'
          as={isTab ? 'p' : 'span'}
        >
          {t('letsBoostYourMicroseries_1')}
        </Text>
        <Text
          size={isMobile ? '2xl' : '5xl'}
          align='center'
          color='headline'
          as={isTab ? 'p' : 'span'}
        >
          <Div
            as='span'
            background='linear-gradient(to right, #B224EF 0%, #7F39FA 100%)'
            WebkitBackgroundClip='text'
            WebkitTextFillColor='transparent'
          >
            {' '}{t('letsBoostYourMicroseries_2')}
          </Div>
        </Text>

        <Div maxWidth={500} margin='0 auto' marginTop={24} marginBottom={6}>
          <Text align='center' size={isMobile ? 'sm' : 'base'}>
            {t('weSupportCreators')}
          </Text>
        </Div>
      </Div>

      <PeopleImage />
    </Container>
  )
}

export default Hero